var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotUploadedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "#F6B40A",
    stroke: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2454 5.29127C9.25308 5.23813 9.25705 5.18379 9.25705 5.12853C9.25705 5.12842 9.25705 5.12831 9.25705 5.1282C9.25687 4.50508 8.75168 4 8.12853 4C7.50537 4 7.00018 4.50508 7 5.1282C7 5.12831 7 5.12842 7 5.12853C7 5.18379 7.00397 5.23813 7.01165 5.29127L7.28205 9.07689C7.28205 9.07724 7.28205 9.07758 7.28205 9.07793C7.28205 9.54538 7.66099 9.92432 8.12844 9.92432C8.59586 9.92432 8.97478 9.54544 8.97484 9.07804H8.97492L9.2454 5.29127ZM8.12844 12.1818C8.5959 12.1818 8.97484 11.8028 8.97484 11.3354C8.97484 10.8679 8.5959 10.489 8.12844 10.489C7.66099 10.489 7.28205 10.8679 7.28205 11.3354C7.28205 11.8028 7.66099 12.1818 8.12844 12.1818Z",
    fill: "#252733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotUploadedIcon);
export default __webpack_public_path__ + "static/media/not-uploaded-icon.d563e53471b107d0717fbdbae30fbccd.svg";
export { ForwardRef as ReactComponent };